export class UsuarioValidacion {
    usuario: string;
    clave: string;
    ipPublica: string;
}